export var Observable = require('zen-observable');
//# sourceMappingURL=zenObservable.js.map